import { render, staticRenderFns } from "./institutionalEntry.vue?vue&type=template&id=51cf6b82&scoped=true"
import script from "./institutionalEntry.vue?vue&type=script&lang=js"
export * from "./institutionalEntry.vue?vue&type=script&lang=js"
import style0 from "./institutionalEntry.vue?vue&type=style&index=0&id=51cf6b82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf6b82",
  null
  
)

export default component.exports